import { render, staticRenderFns } from "./zqjcForm.vue?vue&type=template&id=4d6f16f5&scoped=true&"
import script from "./zqjcForm.vue?vue&type=script&lang=js&"
export * from "./zqjcForm.vue?vue&type=script&lang=js&"
import style0 from "./zqjcForm.vue?vue&type=style&index=0&id=4d6f16f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f16f5",
  null
  
)

export default component.exports